import { SHOW_SIDEBAR, HIDE_SIDEBAR } from 'actions/actionTypes';

export const toggleSidebar = show => dispatch => {
  dispatch({
    type: show ? SHOW_SIDEBAR : HIDE_SIDEBAR
  });
};
